import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { currentFolderState, Folder } from '~/src/ProjectFolder/store';
import { projectListState, wereProjectsLoadedState } from '../store';

export const useFolderSelect = () => {
  const resetResults = useResetRecoilState(projectListState);
  const setCurrentFolder = useSetRecoilState(currentFolderState);
  const setWereProjectsLoaded = useSetRecoilState(wereProjectsLoadedState);

  const handleFolderSelect = (folder: Folder) => {
    resetResults();
    setCurrentFolder(folder);
    setWereProjectsLoaded(false);
  };

  return [handleFolderSelect];
};
